import React from "react";
import { Badge } from "antd";

const StatusBadge = ({ status }) => {
    const statusColor = {
        complete: "green",
        processing: "blue",
        todo: "orange",
        active: "green",
        inactive: "orange",
        offline: "red",
        online: "lime",
        maintenance: "gold",
        repair: "blue",
        retired: "purple"
    };

    return (
        <Badge
            status={status === "todo" && "processing"}
            color={statusColor[status]}
            text={status}
            className="uppercase"
        />
    );
}

export default StatusBadge;
